import { render, staticRenderFns } from "./GroupCourseTable.vue?vue&type=template&id=7d16b193&"
import script from "./GroupCourseTable.vue?vue&type=script&lang=ts&"
export * from "./GroupCourseTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports